import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_BROADCAST = restRequest(
    "VRCORE_DASHBOARD_V2.NEWS_BROADCAST_WIDGET.GET_BROADCAST"
);
export const ADD_BROADCAST = restRequest(
    "VRCORE_DASHBOARD_V2.NEWS_BROADCAST_WIDGET.ADD_BROADCAST"
);
export const UPLOAD_FILE = restRequest("VRCORE_DASHBOARD_V2.NEWS_BROADCAST_WIDGET.UPLOAD_FILE");
export const REMOVE_BROADCAST = restRequest(
    "VRCORE_DASHBOARD_V2.NEWS_BROADCAST_WIDGET.REMOVE_BROADCAST"
);